import BizServePortalHero from "../components/BizServePortalHero";
import BizServePortalIntro from "../components/BizServePortalIntro";
import BizServePortalDomains from "../components/BizServePortalDomains";
import BizServePortalAdvantages from "../components/BizServePortalAdvantages";
import BizServePortalMission from "../components/BizServePortalMission";
import BizServePortalCTA from "../components/BizServePortalCTA";

const BizServePortal = () => {
  return (
    <div className="min-h-screen bg-background">
      <BizServePortalHero />
      <BizServePortalIntro />
      <BizServePortalDomains />
      <BizServePortalAdvantages />
      <BizServePortalMission />
      <BizServePortalCTA />
    </div>
  );
};

export default BizServePortal;
